<template>
  
<h2>Projects</h2>
<div class="container projects">
  <div class="row">
    <div class="col">
      <div class="card" style="width: 18rem;">
  <img src="@/assets/pics/calculator.jpg " class="card-img-top" alt="...">
  <div class="card-body">
    <h5 class="card-title">Javascript Calculator</h5>
  <a href="https://github.com/Blueboykay1/Calculator" class="btn" >Github Repo<i class="fab fa-github"></i> </a>

   <a href="https://app.netlify.com/sites/objective-carson-bd1e16" class="btn" >Visit Site </a>
  </div>
</div>
    </div>
    <div class="col">
      
<div class="card" style="width: 18rem;">
  <img src="@/assets/pics/estore.jpg" class="card-img-top" alt="...">
  <div class="card-body">
    <h5 class="card-title">My E-Store</h5>
    
    <a href="https://github.com/Blueboykay1/MyEstore"  class="btn" >Github Repo<i class="fab fa-github"></i> </a>

   <a href="https://app.netlify.com/sites/eloquent-brahmagupta-bc8aeb" class="btn" >Visit Site </a>
  </div>
</div>

    </div>
    <div class="col">
      
<div class="card" style="width: 18rem;">
  <img src="@/assets/pics/oldp.jpg" class="card-img-top" alt="...">
  <div class="card-body">
    <h5 class="card-title">HTML Portfolio</h5>
   
    <a href="https://github.com/Blueboykay1/NewPortfolio"  class="btn" >Github Repo<i class="fab fa-github"></i> </a>



   <a href="https://thirsty-neumann-2efb6f.netlify.app/" class="btn" >Visit Site </a>
  </div>
</div>
    </div>
  


</div>

 <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>

</div>



</template>

<script>
export default {

}
</script>

<style scoped>
.card-img-top{
  height:125px
}
.card{
  padding: 20px;
}
.btn{
  color: rgb(51, 107, 180);
  
  background-color: black;
}

</style>